/* [BD feat] Testimonials Swiper */
class TestimonialsSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    // Only initialize if Swiper library is loaded
    /* [RR perf] Swiper laedt mit async und kann nach diesem Skript ankommen. Vorher stieg
       die Funktion hier aus und der Slider blieb still stehen. */
    if (typeof Swiper === 'undefined') {
      if (window.bdWhenSwiper) window.bdWhenSwiper(() => this.connectedCallback());
      return;
    }

    const swiperContainer = this.querySelector('.swiper');
    if (!swiperContainer) {
      return;
    }

    const runInit = () => this.initSwiper(swiperContainer);
    if (swiperContainer.offsetWidth < 1) {
      requestAnimationFrame(() => runInit());
    } else {
      runInit();
    }
  }

  initSwiper(container) {
    this.swiper = new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      centeredSlides: true,
      centeredSlidesBounds: true,
      initialSlide: 0,
      loop: false,
      rewind: true,
      speed: 400,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      grabCursor: true,
      simulateTouch: true,
      followFinger: true,
      threshold: 6,
      touchRatio: 1.2,
      resistanceRatio: 0.75,
      watchOverflow: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
      },
      breakpoints: {
        768: {
          /* auto width = card intrinsic width; avoids squeezing 4 columns and clipping 1st/last when row is wider than container */
          slidesPerView: 'auto',
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          centeredSlides: false,
          centerInsufficientSlides: true,
        },
      },
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('testimonials-swiper')) {
  customElements.define('testimonials-swiper', TestimonialsSwiper);
}
/* [BD feat] Testimonials Swiper */
